export const Animation = {
  onLoad: function() {
    if ( $('.will-fade-in').length ) {
      this.setAnimations();
      $(window).scroll(Animation.setAnimations);
    }
  },
  setAnimations: function() {
    const windowWidth = $(window).width();
    // for fade animations on all scren sizes
    $('.will-fade-in').each(function() {
      if ( Animation.isInWindowView( $(this) ) ) {
        $(this).css({
          'opacity': 1,
          'transform': 'translate3d(0,0,0)',
        });
      } else {
        if($(this).hasClass('fadeInDown') || (windowWidth >= 992 && $(this).hasClass('lg-fadeInDown'))) {
          $(this).css({
            'opacity': 0,
            'transform': 'translate3d(0, -100%, 0)',
            '-webkit-transform': 'translate3d(0, -100%, 0)',
            });
        } else if($(this).hasClass('fadeInLeft') || (windowWidth >= 992 && $(this).hasClass('lg-fadeInLeft'))) {
          $(this).css({
            'opacity': 0,
            'transform': 'translate3d(-100%, 0, 0);',
            '-webkit-transform': 'translate3d(-100%, 0, 0)',
          });
        } else if($(this).hasClass('fadeInRight') || (windowWidth >= 992 && $(this).hasClass('lg-fadeInRight'))) {
          $(this).css({
            'opacity': 0,
            'transform': 'translate3d(100%, 0, 0);',
            '-webkit-transform': 'translate3d(100%, 0, 0)',
          });
        } else if($(this).hasClass('fadeInUp') || (windowWidth >= 992 && $(this).hasClass('lg-fadeInUp'))) {
          $(this).css({
            'opacity': 0,
            'transform': 'translate3d(0, 50%, 0);',
            '-webkit-transform': 'translate3d(0, 25%, 0)',
          });
        } else {
          $(this).css({
            'opacity': 0,
          });
        }
      }
    });
    $('.will-bg-in').each(function() {
      if ( Animation.isInWindowView( $(this) ) ) {
        $(this).removeClass('bgGrow');
      } else {
        $(this).addClass('bgGrow');
      }
    });
  },
  isInWindowView: function( $this ) {
    const topOfItem = $this.offset().top - 100,
      bottomOfItem = $this.offset().top + 100 + $this.outerHeight(),
      windowoff = $(window).scrollTop(),
      windowOffset = $(window).scrollTop() + $(window).height();
    return ((windowOffset > topOfItem && windowoff < topOfItem) || (windowOffset > bottomOfItem && windowoff < bottomOfItem) || topOfItem < windowoff && bottomOfItem > windowOffset);
  },
}




// WEBPACK FOOTER //
// ./scripts/common/Animation.js